import type { ActivePromoCampaign, PromoCampaignContext, RegisteredPromoCampaign } from './types';

export function resolveActivePromoCampaignFromList(
  campaigns: RegisteredPromoCampaign[],
  ctx: PromoCampaignContext
): ActivePromoCampaign | null {
  for (const campaign of campaigns) {
    if (!campaign.matches(ctx)) {
      continue;
    }

    const resolved = campaign.resolve(ctx);
    if (resolved == null) {
      continue;
    }

    return { campaign, resolved };
  }

  return null;
}
